import { render, staticRenderFns } from "./TsumPlotXY.vue?vue&type=template&id=7b54c52c&"
import script from "./TsumPlotXY.vue?vue&type=script&lang=js&"
export * from "./TsumPlotXY.vue?vue&type=script&lang=js&"
import style0 from "./TsumPlotXY.vue?vue&type=style&index=0&id=7b54c52c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TsumPlotXY.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports